// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle_title__A9fn5","swoosh":"SectionTitle_swoosh__7-AxO"};